import anime from 'animejs/lib/anime.es.js';
import { getReducedMotion } from '../../utils/animation';
import { ScrollTrigger } from '../scroll-trigger';

export function BlockA() {
	if (getReducedMotion()) {
		return;
	}

	Array.from(document.querySelectorAll('.c-block-a')).forEach(e => create(e));
}

function create(element) {
	let played = false;
	let media = element.querySelector('.c-block-a__media');
	let content = element.querySelector('.c-block-a__content');

	anime.set(media, {
		opacity: 0,
	});

	anime.set(content, {
		opacity: 0,
		translateY: '10%',
	});

	let animation = anime.timeline({
		autoplay: false,
		easing: 'easeInQuad',
	}).add({
		targets: media,
		duration: 600,
		opacity: 1,
	}).add({
		targets: content,
		duration: 1000,
		opacity: 1,
		translateY: 0,
	}, 0);

	ScrollTrigger(element, {
		start: '0.2 1',
		onUpdate: onUpdate,
	});

	function onUpdate(entry) {
		if (played || !entry.isVisible) {
			return;
		}

		played = true;
		animation.play();
	}
}
